import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from 'antd';
import {useTranslation} from 'react-i18next';
import {AlertDiamondIcon} from '../../../../icons';


const ExpensePolicyIcon = ({status}) => {
  const [t] = useTranslation('main');

  return (
    <Tooltip title={t?.(`main:expensePolicyStatuses.${status}`)} placement='right'>
      <span className='d-inline-flex'>
        <AlertDiamondIcon />
      </span>
    </Tooltip>
  );
}

ExpensePolicyIcon.propTypes = {
  status: PropTypes.string,
}

export default ExpensePolicyIcon;
